export const GENEROSITY_WALLET_ALWAYS_ON_EXPERIMENT_ID = "always-on-wallet";
export const GENEROSITY_WALLET_ALWAYS_ON_ENABLED_VARIANT = "always-on";
